// The fallback for a market that has not translated the entries on its account portal page.
const LOG_IN_LABEL = 'Log in';
const REGISTER_LABEL = 'Register';

export { LOG_IN_LABEL, REGISTER_LABEL };
